module.exports = __webpack_public_path__ + "img/product_98.475fd09.webp";